<template>
    <div :class="['form', {'form--add-result': styles, 'scroll-reveal animate__animated': styles}]" data-animation="bounceIn">
        <div v-if="title" class="form__title">{{ $t('game.text.form-title') }}</div>
        <p class="form__desc">{{ $t('game.text.form-description') }}</p>

        <div class="form__group">
            <input v-model.trim="enteredName" type="text" name="name" id="name" :class="['input', {'input--error': !isInputValid}]" :placeholder="$t('game.text.form-placeholder')">
            <div v-if="!isInputValid" class="form__error">{{ $t('game.text.form-error') }}</div>
            <div v-if="error" class="form__error">{{ $t('error-page.error-500-text') }}</div>
        </div>

        <button v-if="!error" @click="publishResult" class="btn btn--secondary">
            {{ $t(buttonText) }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'AddResultForm',
    props: {
        title: {
            type: Boolean,
            required: false,
            default: false
        },
        styles: {
            type: Boolean,
            required: false,
            default: false
        },
        buttonText: {
            type: String,
            required: false,
            default: 'button.publish-result'
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['name-submit'],
    inject: ['scrollTrigger', 'addObserver'],
    data() {
        return {
            enteredName: '',
            isInputValid: true
        }
    },
    methods: {
        validateInput() {
            if (this.enteredName == '') {
                this.isInputValid = false;
                return false;
            } else {
                this.isInputValid = true;
                return true;
            }
        },
        publishResult() {
            if (this.validateInput()) {
                this.$emit('name-submit', this.enteredName);
            }
        }
    },
    mounted() {
        this.scrollTrigger('.scroll-reveal', {
            rootMargin: '-50px'
        });
    }
}
</script>
